import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

// MODIFIED: whole file (to not allow to update quantity if digital product)

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  constructor() {
    super();
    this.locked = false;
  }

  connectedCallback() {
    // Read lock state BEFORE super.connectedCallback() triggers button-state updates
    this.locked = this.dataset.canUpdateQuantity === 'false';
    super.connectedCallback();

    if (this.locked) {
      this.applyLock();
    }
  }

  applyLock() {
    const { quantityInput, minusButton, plusButton } = this.refs;

    // Clamp UI to 1 (optional but usually desired for digital)
    if (quantityInput) {
      quantityInput.value = '1';
      quantityInput.disabled = true;
      quantityInput.readOnly = true;
    }
    if (minusButton) minusButton.disabled = true;
    if (plusButton) plusButton.disabled = true;
  }

  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Respect lock state for digital products
   */
  updateButtonStates() {
    if (this.locked) {
      this.applyLock();
      return;
    }

    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  // Prevent any quantity changes when locked
  updateQuantity(stepMultiplier) {
    if (this.locked) return;
    super.updateQuantity(stepMultiplier);
  }

  setQuantity(event) {
    if (this.locked) {
      if (event?.preventDefault) event.preventDefault();
      this.applyLock();
      return;
    }
    super.setQuantity(event);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
